// Take-Slot-Logik der Recording-Booth als pure Funktion (Audit M24).
//
// Slot-Key ist `(session, voiceId)` (decisions.md 2026-05-13): dieselbe
// Stimme + Generate in derselben Aufnahme ersetzt den Slot, eine neue Stimme
// legt einen neuen an. Beim Ersetzen übernahm der neue Take bisher die ALTE
// ID — der Decode-Cache (`audioPlayback.decodeAndCache`, geschlüsselt nach
// Take-ID) lieferte dann den alten Puffer: falsche Dauer, falscher outPoint,
// und die Take-Karte spielte das alte Audio. Jetzt bekommt jeder erzeugte Take
// eine frische ID; Label (`takeInSession`) und Markierung bleiben.
//
// Sicher, weil Draft-Takes bis „Finish" nur im Overlay leben — keine
// MasterClip-Referenz im Store zeigt auf eine Draft-ID.

export interface DraftSlotTake {
  id: string;
  session?: number;
  voiceId?: string;
  takeInSession?: number;
  marked: boolean;
}

export interface DraftSlotPlan {
  /** ID des Takes, der ersetzt wird (null = neuer Slot). */
  replacesId: string | null;
  /** Frische ID für den neuen Take — auch beim Ersetzen. */
  id: string;
  takeInSession: number;
  marked: boolean;
}

export function mintTakeId(): string {
  return `take-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
}

export function planDraftSlot(
  takes: ReadonlyArray<DraftSlotTake>,
  session: number,
  voiceId: string,
  newId: string = mintTakeId(),
): DraftSlotPlan {
  const existing = takes.find((t) => t.session === session && t.voiceId === voiceId);
  const takeInSession =
    existing?.takeInSession ??
    takes.reduce(
      (max, t) => (t.session === session ? Math.max(max, t.takeInSession ?? 0) : max),
      0,
    ) + 1;
  return {
    replacesId: existing?.id ?? null,
    id: newId,
    takeInSession,
    marked: existing?.marked ?? false,
  };
}
